import { render, staticRenderFns } from "./dellTips.vue?vue&type=template&id=e6142cc2"
import script from "./dellTips.vue?vue&type=script&lang=js"
export * from "./dellTips.vue?vue&type=script&lang=js"
import style0 from "./dellTips.vue?vue&type=style&index=0&id=e6142cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports